import React from "react";
import type { LucideIcon } from "lucide-react";
import { cn } from "../utils";

interface SectionPillHeaderProps {
  icon: LucideIcon;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
  descriptionClassName?: string;
}

export function SectionPillHeader({
  icon: Icon,
  title,
  description,
  action,
  className,
  descriptionClassName,
}: SectionPillHeaderProps) {
  return (
    <div className={cn("flex flex-col gap-2.5", className)}>
      <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        <div className="space-y-1.5">
          <div className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.16em] text-slate-500 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-300">
            <Icon className="h-3.5 w-3.5" />
            {title}
          </div>
          {description ? (
            <p className={cn("max-w-4xl text-sm leading-5 text-slate-600 dark:text-slate-400", descriptionClassName)}>
              {description}
            </p>
          ) : null}
        </div>
        {action ? <div className="shrink-0">{action}</div> : null}
      </div>
    </div>
  );
}
